var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 700",
    width: 650,
    height: 700,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 1950,
    height: 4800,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDY1MCAxNjAwIiB3aWR0aD0iNjUwIiBoZWlnaHQ9IjE2MDAiPjxzdHlsZT4uYXtmaWxsOiNmYmMzYTR9PC9zdHlsZT48cGF0aCBjbGFzcz0iYSIgZD0ibTQ5NC4xIDY0My40YzMxLjQgODguNyA2LjkgNjUuNCAzMy41IDY0IDI2LjYtMS41IDM3LjItMzUuOSAzMS42LTc1LjktMTgtMTI4LjEgMjEtMTc4LjUtMjcuMS0xNzUuOS0yNi42IDEuNS04OS44IDQxLjMtMzggMTg3Ljh6Ii8+PC9zdmc+"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    transform: "matrix(.815,0,0,.815,-956,-1073)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArm);
export default __webpack_public_path__ + "static/media/right_arm.f6bf3bfaa29c3c3877051b13cece5010.svg";
export { ForwardRef as ReactComponent };